const supportedLocales = getSupported()

function getSupported() {
    let languages = {}
    if (parseBoolean(process.env.VUE_APP_LOCALE_SUPPORT_EN, true)) {
        languages.en = "English"
    }
    if (parseBoolean(process.env.VUE_APP_LOCALE_SUPPORT_DE, true)) {
        languages.de = "Deutsch"
    }
    if (parseBoolean(process.env.VUE_APP_LOCALE_SUPPORT_FR, true)) {
        languages.fr = "French"
    }
    if (parseBoolean(process.env.VUE_APP_LOCALE_SUPPORT_NL, true)) {
        languages.nl = "Dutch"
    }
    if (parseBoolean(process.env.VUE_APP_LOCALE_SUPPORT_IT, true)) {
        languages.it = "Italian"
    }
    if (parseBoolean(process.env.VUE_APP_LOCALE_SUPPORT_NO, true)) {
        languages.no = "Norwegian"
    }
    if (parseBoolean(process.env.VUE_APP_LOCALE_SUPPORT_ES, true)) {
        languages.es = "Spanish"
    }
    if (parseBoolean(process.env.VUE_APP_LOCALE_SUPPORT_PT, true)) {
        languages.pt = "Portuguese"
    }
    // console.log("supported locales languages", languages)
    return languages
}

function parseBoolean(value, fallback) {
    if (typeof value === 'undefined') {
        return fallback
    }
    switch (typeof fallback) {
        case 'boolean' :
            return !!JSON.parse(value)
        case 'number' :
            return JSON.parse(value)
        default :
            return value
    }
}

export default supportedLocales;